import { FieldsToFilter } from '@/components/dataGrid/components/filters/filters';
import DataGrid, { DataGridProps } from '@/components/dataGrid/dataGrid';
import { DataGridAction, DataGridColumn } from '@/components/dataGrid/entities/types';
import { ListResponse } from '@/components/dataGrid/hooks/useRequestData/usePaginatedList';
import { BaseSearchParams } from '@/shared/entities';
import { extractValuesByKeys } from '@/utils/extractValuesByKeys/extractValuesByKeys';
import React from 'react';

export interface DataGridControllerProps<
  Response extends ListResponse,
  Filter extends BaseSearchParams,
  ColumnNames extends string = string,
  FilterNames extends string = string,
  ActionNames extends string = string,
  Data = Response['data'][0],
> extends Omit<
    DataGridProps<Response, Filter, DataGridProps<Response, Filter>>,
    'columns' | 'filters' | 'actionsByItem'
  > {
  visibleColumns?: ColumnNames[];
  visibleFilters?: FilterNames[];
  visibleActions?: ActionNames[];
  columnByName: Record<ColumnNames, DataGridColumn<Data, Filter>>;
  filterByName?: Record<FilterNames, FieldsToFilter<Filter>>;
  actionByName?: Record<ActionNames, DataGridAction<Data>>;
}

export const DataGridController = function DataGridController<
  Response extends ListResponse,
  Filter extends BaseSearchParams,
  ColumnNames extends string = string,
  FilterNames extends string = string,
  ActionNames extends string = string,
>({
  visibleColumns,
  visibleFilters,
  visibleActions,
  columnByName,
  filterByName,
  actionByName,

  // Rest of the props are directly passed to DataGrid
  ...restProps
}: DataGridControllerProps<Response, Filter, ColumnNames, FilterNames, ActionNames>) {
  return (
    <DataGrid
      columns={extractValuesByKeys(columnByName, visibleColumns)}
      filters={filterByName ? extractValuesByKeys(filterByName, visibleFilters) : undefined}
      actionsByItem={actionByName ? extractValuesByKeys(actionByName, visibleActions) : undefined}
      {...restProps}
    />
  );
};
